export default "__VITE_ASSET__LSG5MLuJ__"